import { connect } from 'react-redux';
import App from 'common/backbone-app';
import Wahanda from 'common/wahanda';
import { isFeatureEnabled } from 'common/trunk-features/store/selectors';

import { Routes } from './';
import { isAppointmentMessageLogAccessible } from '../appointmentMessageLogAccess';
import {
  PROMOTIONAL_OFFERS_CHANNEL_FEATURE,
  CLIENT_APP_ENABLED_CHANNEL_FEATURE,
  CLIENT_APP_CAMPAIGN_CHANNEL_FEATURE,
} from '../chnlFeatures';

const mapStateToProps = (state) => ({
  isClientAppEnabled:
    App.isFeatureSupported(CLIENT_APP_ENABLED_CHANNEL_FEATURE) && App.isVenueListedOnMarketplace(),
  isEmailCampaignsAccessible: Wahanda.Permissions.anyEmailCampaignEnabled(),
  isPromoOffersCampaignsEnabled: App.isFeatureSupported(PROMOTIONAL_OFFERS_CHANNEL_FEATURE),
  isAppForYourClientsCampaignEnabled:
    App.isFeatureSupported(CLIENT_APP_CAMPAIGN_CHANNEL_FEATURE) && App.isVenueListedOnMarketplace(),
  isPartnerSiteAccessible: Wahanda.Permissions.canAccessPartnerSites(),
  isClientFormsAccessible: isFeatureEnabled(state, 'CAR-2635-client-forms-page'),
  isAppointmentMessageLogAccessible: isAppointmentMessageLogAccessible(state),
});

export const MarketingRouter = connect(mapStateToProps)(Routes);
